export interface DashboardOpcButton {
  id: number;
  dashboardId: number;
  type: string;
  row: number;
  column: number;
  name: string;
  style: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  fontSize: string;
  linkToDashBoard: number;
  opcClientId: number;
  opcClientInstanceName: string;
  nodeId: string;
  opcValueDataType: string;
  counterIncrementDifference: number;
  pulseInMs: number;
}

export interface DashboardOpcButtonInputs {
  id?: number;
  dashboardId: number;
  type?: string;
  row: number;
  column: number;
  name?: string;
  style?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  fontSize?: string;

  linkToDashBoard?: number;
  opcClientId?: number;
  opcClientInstanceName?: string;
  nodeId?: string;
  opcValueDataType?: string;
  counterIncrementDifference?: number;
  pulseInMs?: number;
}

export interface DashboardDashboardOpcButtonListType {
  code: string;
  name: string;
}

export enum DashboardOpcButtonTypes {
  LINK_TO_DASHBOARD = 'LinkToDashboard',
  COUNTER_INCREMENT = 'CounterIncrement',
  SET_NEW_VALUE = 'SetNewValue',
  SET_TRUE = 'SetTrue',
  SET_FALSE = 'SetFalse',
  SET_VALUE_TO_ZERO = 'SetValueToZero',
}

export const dashboardOpcButtonTypes: DashboardDashboardOpcButtonListType[] = [
  {
    code: 'LinkToDashboard',
    name: 'Link to dashboard',
  },
  {
    code: 'CounterIncrement',
    name: 'Counter increment',
  },
  {
    code: 'SetNewValue',
    name: 'Set new value',
  },
  {
    code: 'SetTrue',
    name: 'Set true',
  },
  {
    code: 'SetFalse',
    name: 'Set false',
  },
  {
    code: 'SetValueToZero',
    name: 'Set value to zero',
  },
];

export enum DashboardOpcButtonStyle {
  RED = 'opc-button-red',
  GREEN = 'opc-button-green',
  BLUE = 'opc-button-blue',
}

export const dashboardOpcButtonStyles: DashboardDashboardOpcButtonListType[] = [
  {
    code: 'primary',
    name: 'Orange',
  },
  {
    code: 'secondary',
    name: 'Gray',
  },
  {
    code: 'success',
    name: 'Green',
  },
  {
    code: 'error',
    name: 'Red',
  },
  {
    code: 'info',
    name: 'Blue',
  },
];

export enum DashboardOpcButtonDataType {
  BOOLEAN = 'Boolean',
  INT = 'Int',
  LONG = 'Long',
  FLOAT = 'Float',
  DOUBLE = 'Double',
  STRING = 'String',
}

export const dashboardOpcButtonDataTypes: DashboardDashboardOpcButtonListType[] = [
  {
    code: 'Boolean',
    name: 'Boolean',
  },
  {
    code: 'Int',
    name: 'Int',
  },
  {
    code: 'Long',
    name: 'Long',
  },
  {
    code: 'Float',
    name: 'Float',
  },
  {
    code: 'Double',
    name: 'Double',
  },
  {
    code: 'String',
    name: 'String',
  },
];
